import React from "react";
import OurStory from "../../components/OurStory/OurStory";
import HomeBelowCards from "../../components/HomeBelowCards/HomeBelowCards";
import AboutUsVision from "../../components/AboutUsVision/AboutUsVision";
const homeBelowCards = [
  {
    title: "Our Vision",
    description: `Be the foremost provider of innovative and transformative enterprise solutions. We aspire to create a future where businesses seamlessly integrate advanced technologies, achieve unparalleled operational excellence, and continuously adapt to emerging market trends. Through our expertise, we envision being the driving force behind our clients' sustained success and evolution`,
    bgImage: "/assests/our_vision.jpg",
    reverseOrder:true,
  },
];
const Aboutus = () => {
  return (
    <section>
      <OurStory />
      {homeBelowCards.map((card) => (
        <HomeBelowCards {...card} />
      ))}
      <AboutUsVision />
    </section>
  );
};

export default Aboutus;
